"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleClick = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var toggleClick = function (event) {
    var eventData = {
        event: analytics_layer_1.LinkInteractionEventNames.ToggleClick,
        eventInfo: analytics_layer_1.LinkInteractionEventNames.ToggleClick,
        toggle: {
            toggleName: event.eventData.toggle.toggleName || consts_1.NOT_AVAILABLE,
            toggleAction: event.eventData.toggle.toggleAction || consts_1.NOT_AVAILABLE,
        },
    };
    return eventData;
};
exports.toggleClick = toggleClick;
